export default {
  metadata: {
    version: '1.0.0',
    id: 'table-row-1.0.0',
    name: 'JDSTableRow'
  },
  hierarchy: {
    container: ['jds_table_cell']
  },
  base: {
    container: {
      'flex-direction': '{t_0}',
      'lazy-scroll-android': false,
      width: '{intrinsicSize.max}'
    },
    jds_table_cell: {
      width: '{size.max}'
    }
  },
  variant: {
    density: {
      condensed: {
        jds_table_cell: {
          density: 'condensed'
        }
      }
    },
    columnDivider: {
      true: {
        jds_table_cell: {
          columnDivider: true
        }
      }
    }
  },
  api: {
    config: {
      density: {
        type: 'JDSTableCell.density',
        values: ['relaxed', 'condensed']
      },
      columnDivider: {
        values: [false, true]
      }
    },
    data: {
      container: {
        value: {
          type: 'list',
          name: 'cells',
          object: {
            text: 'string',
            type: 'JDSTableCell.type',
            background: 'boolean'
          }
        }
      },
      jds_table_cell: {
        label: {
          name: 'cells.text',
          type: 'string'
        },
        type: {
          name: 'cells.type',
          type: 'JDSTableCell.type'
        },
        background: {
          name: 'cells.background',
          type: 'boolean'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'row'
          }
        }
      }
    }
  }
};
